<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    翻身站<br>
站点介绍<br>
翻身站是位于宝安区翻身村创业一路与翻身路交叉口西侧，顺创业一路布置。北侧是海天花园、洪福雅苑等新的成熟社区和部分旧村，南侧富源商贸中心、天虹商场、碧海花园、安乐小学以及其他社区和旧村。东侧为创业路立交桥，车站周围有尖沙咀外贸城、天虹商场、富源商贸中心、等大型购物中心。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:10	23:59	5号线	3分钟	5分25秒<br>
黄贝岭	06:21	23:22	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:10	23:59	5号线	4分钟	6分钟<br>
黄贝岭	06:28	23:22	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:10	00:59	5号线	4分钟	6分钟<br>
黄贝岭	06:28	00:22	5号线	4分钟	6分钟<br><br>

站点出口信息<br>
A出入口:<br>
宝安大道（东）、创业一路南侧（西）、西城上筑<br><br>
B出入口:<br>
创业一路南侧（东）、翻身路西侧（南）、创业天虹、安乐小学、海滨中学<br><br>
C出入口:<br>
创业一路北侧、翻身路西侧（北）、洪福雅苑、海天花园、海滨广场、翻身实验学校、48区步行街、裕安一路
公交换乘信息<br><br>
A出入口:<br>
公交站名： 翻身地铁站<br>
E15、E36、M131、M375、M376、M377、M379、M483、高快巴士33、旅游9线、B687<br><br>
B出入口:<br>
公交站名： 翻身地铁站①<br>
M197<br><br>
C出入口:<br>
公交站名： 翻身地铁站<br>
M375、M376、M377、M379、M483、高快巴士33、旅游9线<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


